import api from '../../api/api_resource'
import axios from "axios/index";
import LaravelRouter from "../../thirdparty/Ziggy/route";
import {saveVuexState} from "../../util/common";

const saveState = (state) => {
    const newState = JSON.parse(JSON.stringify(state))
    newState.all = []
    newState.ids = []
    saveVuexState('favourites_state', newState)
}

let favouritesState = window.sessionStorage.getItem('favourites_state')
let state
if (favouritesState) {
    try {
        state = JSON.parse(favouritesState)
    } catch (e) {
        state = null
    }
}
if (state && state.state && state.expiration && state.expiration > Date.now()) {
    state = state.state
} else {
    state = null
}
if (!state) {
    state = {
        ids: [],
        id_map: {},
        all: [],
        current_page: 1,
        all_favourites_count: 1,
        all_favourites_users: [],
        favourite_lists: [],
        per_page: 2000,
        from: 1,
        to: 2000,
        last_page: null,
        total: null,
        last_state_key: null,
        selected_vehicles: [],
        auction_date: [],
        query_count: 0,
    }
}

// getters
const getters = {
    all: state => state.all,
    all_favourites_count: state => state.all_favourites_count,
    ids: state => state.ids,
    current_page: state => state.current_page,
    getLastStateKey: state => state.last_state_key,
    getSelectedVehicles: state => state.selected_vehicles,
};

function hasFavourite(vehicle_id) {
    let found = false;
    state.all.forEach((item, index) => {
        if (item.vehicle_id === vehicle_id) {
            found = index;
        }
    });
    return found;
}

// actions
const actions = {
    getIds({ commit, state }) {
        api.index('favourites').then(favourites => {
            commit('setFavouritesIds', favourites.data);

        })
    },
    getFavourites({ commit, state }, args) {
        commit('incrementQueryCount')
        let query_number = state.query_count
        return new Promise((success, error) => {
            const search_args = Object.assign({
                page: state.current_page,
                per_page: state.per_page,
            }, args);
            api.index('favourites', search_args).then(favourites => {
                if (query_number === state.query_count) {
                    commit('setFavourites', favourites);
                    success(favourites);
                } else {
                    error('favourites request was proceded by another')
                }
            }).catch(error);
        });
    },
    async toggleFavourite({ commit, state }, vehicle_id) {
        try {
            let res = await api.post('favourites.toggle', vehicle_id, {vehicle_id})
            return res;
        } catch (e) {
            console.warn(e)
        }
    },
    addFavourite({ commit, state }, vehicle_id) {
        return new Promise((success, reject) => {
            api.store('favourites', {vehicle_id}).then(result => {
                commit('addId', vehicle_id)
                success(true)
            }).catch(reject);
        });
    },
    removeFavourite({ commit, state }, vehicle_id) {
        return new Promise((success, reject) => {
            // api.destroy('favourites', vehicle_id).then(result => {
            //     commit('removeFavourite', vehicle_id)
            //     success(true)
            // }).catch(reject);
            let config = {data: {vehicle_id}};
            let route = LaravelRouter(`favourites.bulkDestroy`, [], true);
            axios.delete(route, config).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    reject(response);
                }
            }).catch(response => {
                reject(response);
            });
        });
    },
    removeList({ commit, state }, {list_id}) {
        return new Promise((success, reject) => {
            api.destroy('favourite-list', list_id).then(() => {
                commit('removeList', list_id)
                success(true)
            }).catch(reject);
        });
    },
    getFavouriteList({ commit, state }, args) {
        return new Promise((success, error) => {
            const search_args = Object.assign({
                page: state.current_page,
                per_page: state.per_page
            }, args);
            api.index('favourite-list', search_args).then(favourites => {
                commit('setFavouritesList', favourites);
                success(favourites);
            }).catch(error);
        });
    },
    getFavouriteListByUser({ commit, state }, args) {
        args = args ? args : null;
        return new Promise((success, error) => {
            api.index('favourite-list', args).then(favourites => {
                success(favourites);
            }).catch(error);
        });
    },
    getFavouriteListForFavouritesPage({ commit, state }, args) {
        return new Promise((success, error) => {
            const search_args = Object.assign({
                page: 1,
            }, args);
            api.index('favourite-list', search_args).then(res => {
                if (res && res.favourites.data) {
                    success(res.favourites.data);
                    commit('setFavouriteLists', res.favourites.data)
                } else{
                    error('There was a problem getting favourite list.');
                }
            }).catch(error);
        });
    },
    storeFavouriteList({ commit, state }, args) {
        return new Promise((success, error) => {
            const search_args = Object.assign({
                page: state.current_page,
                per_page: state.per_page
            }, args);
            api.store('favourite-list', search_args).then(userlist => {
                success(userlist);
            }).catch(error);
        });
    },
    deleteFavouriteUser({ commit, state }, args) {
        args = args ? args : null;
        return new Promise((success, error) => {
            let route = LaravelRouter(`delete-favourite-user.delete`, [], true);
            axios.post(route, args).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    sendFavouriteList({ commit, state }, args) {
        args = args ? args : null;
        return new Promise((success, error) => {
            let route = LaravelRouter(`send-favourite-list.sendlist`, [], true);
            axios.post(route, args).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    getFavouritesAuctionDates({ commit, state }, args){
        return new Promise((success, error) => {
            let route = LaravelRouter(`favourites.auction-dates`, args, true);
            axios.get(route).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    copyFavouriteList({ commit, state }, args) {
        args = args ? args : null;
        return new Promise((success, error) => {
            let route = LaravelRouter(`favourite-list.copyList`, [], true);
            axios.post(route, args).then(response => {
                if (response && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
};

// mutations
const mutations = {
    setFavourites (state, result) {
        state.last_state_key = window.history.state && window.history.state.key ? window.history.state.key : null
        state.all = result.data;
        let id_map = {};
        let ids = [];
        state.all.forEach((item, i) => {
            ids.push(item.id);
            id_map[item.id] = i;
        });
        state.selected_vehicles = ids
        state.id_map = id_map;
        state.ids = ids;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
        saveState(state)
    },
    setFavouritesList (state, result) {
        state.all = result.favourites.data;
        let id_map = {};
        let ids = [];
        state.all.forEach((item, i) => {
            ids.push(item.id);
            id_map[item.id] = i;
        });
        state.id_map = id_map;
        state.all_favourites_count = result.all_favourites_count;
        state.all_favourites_users = result.all_favourites_users;
        state.ids = ids;
        state.current_page = result.favourites.current_page;
        state.per_page = parseInt(result.favourites.per_page);
        state.from = result.favourites.from;
        state.to = result.favourites.to;
        state.last_page = result.favourites.last_page;
        state.total = result.favourites.total;
        state.auction_date = result.auction_date;
        saveState(state)
    },
    setAllFavourites (state, favourites) {
        let favs = [];
        favourites.forEach(fav => {
            favs.push(fav);
        });
        state.all = favs;
        saveState(state)
    },
    setCurrentPage (state, page) {
        state.current_page = page
        saveState(state)
    },
    setFavouritesIds (state, favourites) {
        let favs = [];
        favourites.forEach(fav => {
            favs.push(fav.api_id);
        });
        state.ids = favs;
        saveState(state)
    },
    addId(state, vehicle_id) {
        let found = state.ids.indexOf(vehicle_id);
        if (found === -1) {
            state.ids.push(vehicle_id);
        }
        saveState(state)
    },
    removeId(state, vehicle_id) {
        let found = state.ids.indexOf(vehicle_id);
        if (found !== -1) {
            state.ids.splice(found, 1);
        }
        saveState(state)
    },
    removeFavourite(state, vehicle_id) {
        let found = hasFavourite(vehicle_id);
        if (found !== false) {
            state.all.splice(found, 1);
        }
        saveState(state)
    },
    removeList(state, list_id) {
        let found = false;
        state.all.forEach((item, index) => {
            if (item.id === list_id) {
                found = index;
            }
        });
        if (found !== false) {
            state.all.splice(found, 1);
        }
        saveState(state)
    },
    /**
     * Add or update a user in a favourite list
     * @param state
     * @param list_id
     * @param user
     */
    updateUser(state, {list_id, user}){
        if (typeof state.id_map[list_id] !== 'undefined') {
            let index = state.id_map[list_id];
            let found = false;
            state.all[index].users.forEach((list_user, i) => {
                if (list_user.id === user.id) {
                    found = i;
                    state.all[index].users[i] = user;
                }
            });
            if (found === false) {
                state.all[index].users.push(user);
            }
        }
        saveState(state)
    },
    /**
     * Remove a user from a favourite list
     * @param state
     * @param list_id
     * @param user_id
     */
    removeUser(state, {list_id, user_id}){
        if (list_id !== 0) {
            if (typeof state.id_map[list_id] !== 'undefined') {

                let index = state.id_map[list_id];
                let found = false;
                state.all[index].users.forEach((user, i) => {
                    if (found === false && user.id === user_id) {
                        state.all[index].users.splice(i, 1 );
                    }
                });
            }
        } else {
            const state_aux = _.clone(state.all_favourites_users)
            state.all_favourites_users = state_aux.filter( user => user.id !== user_id);
        }
        saveState(state)
    },
    incrementQueryCount(state) {
        state.query_count++
        saveState(state)
    },
    setFavouriteLists(state, favourites) {
        const lists = [];
        favourites.forEach(list => {
            lists.push({
                value: list.id,
                text: `${list.name} (${list.vehicles_count})`
            });
        });
        state.favourite_lists = lists
        saveState(state)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/favourites.js